export default __webpack_public_path__ + "static/media/Logotype-Riksforbundet-Svensk-Tradgard.13b1bb3b.svg";